<template>
  <div class="Gallery">
    <div :class="galleryWrapperClass">
      <flickity ref="flickity" :options="conf" v-if="!isTouch">
        <slot></slot>
      </flickity>
      <div class="items" v-else>
        <slot></slot>
      </div>
      <button class="prev btn" @click="previous()" :style="prevStyle"></button>
      <button class="next btn" @click="next()" :style="prevStyle"></button>
    </div>
  </div>
</template>

<script>

  import Flickity from 'vue-flickity';

  export default {
    name: 'Gallery',
    components:{
      Flickity
    },

    data(){
      return {
      };
    },
    methods: {
      next() {
        this.$refs.flickity.next();
      },
      
      previous() {
        this.$refs.flickity.previous();
      }
    },
    props: {
      isFullScreen: {
        type: Boolean,
        default: true
      },
      conf: {
        type: Object,
        default: ()=>{
          return {
            prevNextButtons: false,
            pageDots: false,
            contain: true,
            wrapAround: false,
            cellAlign: 'left'
          }
        }
      },
      prevStyle: {
        type: Object,
        default: ()=>{
          return {
          }
        }
      },
      nextStyle: {
        type: Object,
        default: ()=>{
          return {
          }
        }
      }
    },
    computed: {
      isTouch(){
        return document.querySelector('html').classList.contains('touch');
      },
      galleryWrapperClass(){
        let noFLK = this.isTouch ? 'noFLK' : '';
        return `std-carousel ${noFLK} ${this.isFullScreen ? '' : 'container'}`;
      }
    }

  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';
  .Gallery{
    width: 100%;
    .container{ position: relative; }
  }

  .container.noFLK{
    @media (max-width: @bootstrap-md - 1px){
      padding-left: 0;
      padding-right: 0;
    }
  }

  .btn{
    width: 29px;
    height: 35px;
    position: absolute;
    top: 50%;
    margin-top: -44px;
    z-index: 100;
    background-color: transparent;
    outline: none;
    border: none;
    display: block;
    background-image: url(../../img/arrow_flickity.svg);
    @media (max-width: @bootstrap-md - 1px){
      display: none !important;
    }
    &:hover{
      cursor: pointer;
    }
    &.prev{
      transform: rotate3d(0,0,1, -180deg);
      left: -27px;

    }
    &.next{
      right: -27px;
    }
  }
</style>
